import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import CategoryCard from '@/components/base/CategoryCard';
import { categories } from '@/mocks/categories';

const articleCategories = [
  { slug: 'getting-started', name: '入门指南', icon: 'ri-guide-line' },
  { slug: 'membership', name: '会员指南', icon: 'ri-vip-crown-line' },
  { slug: 'community', name: '社区攻略', icon: 'ri-group-line' },
];

export default function Categories() {
  const [activeTab, setActiveTab] = useState<'manga' | 'article'>('manga');
  const [selectedArticleCat, setSelectedArticleCat] = useState('getting-started');

  useEffect(() => {
    document.title = '分类导航 | JM Comic – 官方入口与完整使用指南';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Breadcrumb items={[{ label: '分类导航' }]} />

      <section className="py-10 md:py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              分类导航
            </h1>
            <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
              浏览漫画分类或使用指南分类，快速找到您感兴趣的内容
            </p>
          </div>

          <div className="flex justify-center mb-10">
            <div className="inline-flex bg-background-100 rounded-full p-1">
              <button
                onClick={() => setActiveTab('manga')}
                className={`px-6 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeTab === 'manga'
                    ? 'bg-background-50 text-foreground-950'
                    : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                漫画分类
              </button>
              <button
                onClick={() => setActiveTab('article')}
                className={`px-6 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeTab === 'article'
                    ? 'bg-background-50 text-foreground-950'
                    : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                文章分类
              </button>
            </div>
          </div>

          {activeTab === 'manga' && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categories.map((cat) => (
                <CategoryCard
                  key={cat.slug}
                  slug={cat.slug}
                  name={cat.name}
                  icon={cat.icon}
                  description={cat.description}
                  count={cat.count}
                  color={cat.color}
                />
              ))}
            </div>
          )}

          {activeTab === 'article' && (
            <>
              <div className="flex justify-center gap-4 mb-8 flex-wrap">
                {articleCategories.map((ac) => (
                  <button
                    key={ac.slug}
                    onClick={() => setSelectedArticleCat(ac.slug)}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                      selectedArticleCat === ac.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:text-foreground-800'
                    }`}
                  >
                    <i className={ac.icon}></i>
                    {ac.name}
                  </button>
                ))}
              </div>
              <div className="text-center py-12">
                <p className="text-foreground-600 mb-4">
                  请在具体分类页面中浏览该分类下的文章
                </p>
                <Link
                  to={`/category/${selectedArticleCat}`}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  前往「{articleCategories.find((a) => a.slug === selectedArticleCat)?.name}」
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}